import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  CircularProgress,
  TextField,
} from "@mui/material";
import api from "../services/api";

export default function OcrDebugPanel({ user }) {
  const [file, setFile] = useState(null);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);

  const handleUpload = async () => {
    if (!file) return;

    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await api.post("/ocr/debug-text", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setText(res.data.fullText || "No text detected.");
    } catch (err) {
      console.error("OCR debug failed:", err);
      setText("❌ Failed to extract text.");
    }

    setLoading(false);
  };

  const isAllowed =
    user?.email === "youremail@example.com" ||
    user?.uid === "UQJSZFi9wigvsrlEF7PjTiNuFK42";

  if (!isAllowed) return null;

  return (
    <Paper sx={{ p: 4, mt: 4 }}>
      <Typography variant="h6" gutterBottom>
        🧪 OCR Debug Panel
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Upload any receipt file to see the raw Google Vision OCR output.
      </Typography>

      <input
        type="file"
        accept="image/*,application/pdf"
        onChange={(e) => setFile(e.target.files[0])}
        style={{ marginBottom: 16 }}
      />

      <Button
        variant="contained"
        onClick={handleUpload}
        disabled={loading || !file}
      >
        {loading ? <CircularProgress size={20} /> : "Extract Text"}
      </Button>

      {text && (
        <TextField
          multiline
          fullWidth
          rows={16}
          value={text}
          sx={{ mt: 3 }}
          InputProps={{ readOnly: true }}
        />
      )}
    </Paper>
  );
}
